(function (){
    'use strict';

    angular
        .module('services')
        .service('AtmService', AtmService);

    AtmService.$inject = ['$http', 'API_BASE'];

    function AtmService ($http, API_BASE) {
        var service = this;
        service.getByFilter = getByFilter;

        function getByFilter(query) {
            return $http.get(API_BASE + '/financial/atm/list',{params:query});
        }
    }
})();